import { GetApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

type GetSuggestionsResponse = DataSchema.Suggest;

export const getSuggestionsApi = (apiClient: GetApiClient) => {
  return apiClient.get<GetSuggestionsResponse>("/api/suggestions");
};
